import "./SolutionForAgenciesAndFreelancers.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ProblemSolution from "./sections/ProblemSolution";
import EngineAnimation from "./sections/EngineAnimation";
import MoneyMathMarge from "./sections/MoneyMathMarge";
import AgenturFeatures from "./sections/AgenturFeatures";
import Ablauf from "./sections/Ablauf";
import WhatOurCommunitySays from "./sections/WhatOurCommunitySays";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SolutionForAgenciesAndFreelancersPage() {
  return <div>
      <Header />
      <Hero />
      <ProblemSolution />
      <EngineAnimation />
      <MoneyMathMarge />
      <AgenturFeatures />
      <Ablauf />
      <WhatOurCommunitySays />
      <CallToAction />
      <Footer />
    </div>;
}